export default __webpack_public_path__ + "static/media/image-10.ef863369.jpg";